import {useParams} from "react-router";

import {IRankingAnnualParams} from "@pg-mono/rp-routes";

import {ArchiveRanking} from "../components/archive_ranking/ArchiveRanking";
import {OfferRanking} from "../components/offer_ranking/OfferRanking";

export const RankingAnnualView = () => {
    const params = useParams<IRankingAnnualParams>();

    if (!params.year) {
        return <OfferRanking />;
    }

    return <ArchiveRanking />;
};
import {useParams} from "react-router";

import {IRankingAnnualParams} from "@pg-mono/rp-routes";

import {ArchiveRanking} from "../components/archive_ranking/ArchiveRanking";
import {OfferRanking} from "../components/offer_ranking/OfferRanking";

export const RankingAnnualView = () => {
    const params = useParams<IRankingAnnualParams>();

    if (!params.year) {
        return <OfferRanking />;
    }

    return <ArchiveRanking />;
};
